import React from "react";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { useContext } from "../../../../context";
import { MinimizeIcon } from "../../../../../../../../assets/Icons/MinimizeIcon";
import { MaximizeIcon } from "../../../../../../../../assets/Icons/MaximizeIcon";
import styles from "./styles.module.scss";

export const Header = () => {
  const { tSettings: t } = useAppTranslation.Settings({ keyPrefix: "survey" });

  const { layout } = useContext();

  return (
    <div className={styles.root}>
      <button onClick={layout.preview.toggle}>
        {layout.preview.isFullView ? (
          <MinimizeIcon width="18px" />
        ) : (
          <MaximizeIcon width="18px" />
        )}
        {layout.preview.isFullView
          ? t("preview.toggle.view_normal")
          : t("preview.toggle.view_full")}
      </button>
    </div>
  );
};
